const traits = {
        name: '',
        age: '',
        gender: '',
        hairColor: '',
        eyeColor: '',
        height: '',
        born: '',
        lives: '',
        specialAbility: '',
        favoriteItem: '',
        hobby: '',
        extraDetails: '',
        relations: '',
    };

export default traits;